import { render, staticRenderFns } from "./LogoutForm.vue?vue&type=template&id=158be65a&scoped=true"
import script from "./LogoutForm.vue?vue&type=script&lang=js"
export * from "./LogoutForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158be65a",
  null
  
)

export default component.exports